import Swiper from "swiper";
import { A11y, Autoplay, EffectFade, Navigation, Pagination, Scrollbar } from "swiper/modules";
import { fireEvent } from "@/scripts/common/util";

export default {
  init: () => {
    document.querySelectorAll("[data-media-slider]").forEach((el) => {
      const container = el.querySelector(".swiper");
      const sliderNavigation = el.querySelector(".slider-navigation");
      const sliderPagination = el.querySelector(".slider-pagination");
      const sliderScrollbar = el.querySelector(".swiper-scrollbar");
      const asMultipleVideos = el.querySelectorAll(".media-item.as-video").length > 1;
      const numSlides = el.querySelectorAll(".swiper-slide");

      if (!container) {
        return;
      }

      const opts = {
        modules: [A11y, Autoplay, EffectFade, Navigation, Pagination, Scrollbar],
        effect: "fade",
        loop: numSlides > 1,
        speed: 800,
        observer: true,
        observeParents: true,
        resizeObserver: true,
        autoplay: {
          delay: 3500,
          pauseOnMouseEnter: true,
        },
        pagination: {
          el: sliderPagination,
          clickable: true,
          renderBullet: (index, className) => {
            return `
              <span class="${className}" style="flex: 1; height: 100%; position: relative; overflow: hidden;">
                <span class="position-bullet" style="position: absolute; top: 50%; right: -11px; transform: translate(-50%, -50%); width: var(--spacing-slider-bullet-size); height: var(--spacing-slider-bullet-size); background-color: #FFF; border-radius: 50%; z-index: 10;"></span>
                <span class="progress-track" style="position: absolute; top: 0; left: 0; height: 100%; width: 0; background-color: var(--color-highlight); z-index: 1;"></span>
              </span>`;
          },
        },
      };

      if (sliderNavigation) {
        opts.navigation = {
          nextEl: el.querySelector(".slider-button-next"),
          prevEl: el.querySelector(".slider-button-prev"),
        };
      }

      if (sliderScrollbar) {
        opts.scrollbar = {
          el: sliderScrollbar,
          draggable: true,
        };
      }

      const swiper = new Swiper(container, opts);

      const refresh = () => swiper.update();

      if (document.fonts && document.fonts.ready) {
        document.fonts.ready.then(refresh);
      }

      if (document.readyState === "complete") {
        requestAnimationFrame(refresh);
      } else {
        window.addEventListener("load", () => requestAnimationFrame(refresh), { once: true });
      }

      if (sliderPagination) {
        swiper.on("slideChange", function() {
          const bullets = sliderPagination.querySelectorAll('.swiper-pagination-bullet');

          if (swiper.previousIndex > swiper.activeIndex && swiper.activeIndex === 0) {
            bullets.forEach(bullet => {
              bullet.classList.remove('completed');
              const progressTrack = bullet.querySelector('.progress-track');
              if (progressTrack) progressTrack.style.width = '0';
            });
          } else {
            for (let i = 0; i < swiper.activeIndex; i++) {
              if (bullets[i]) {
                bullets[i].classList.add('completed');
                const progressTrack = bullets[i].querySelector('.progress-track');
                if (progressTrack) progressTrack.style.width = '100%';
              }
            }
          }
        });
      }

      if (asMultipleVideos) {
        container.querySelectorAll(".media-item.as-video video").forEach((video) => {
          video.loop = false;
          video.addEventListener("ended", () => {
            swiper.slideNext();
          });
        });

        swiper.on("slideChange", () => {
          const activeSlide = swiper.slides[swiper.activeIndex];
          activeSlide.querySelector("video").play();
        });
      } else {
        swiper.autoplay.stop();

        if (el.closest("[data-media-slider-listener]")) {
          swiper.on("slideChange", () => {
            fireEvent("slide:change", el.closest("[data-media-slider-listener]"), { index: swiper.activeIndex });
          });
        }
      }

      const start = () => {
        if (asMultipleVideos) {
          const activeSlide = swiper.slides[swiper.activeIndex];
          activeSlide.querySelector("video").play();
        } else {
          swiper.autoplay.start();
        }
      };

      const observer = new IntersectionObserver(
        ([e]) => {
          if (e.isIntersecting) {
            start();
            observer.disconnect();
          }
        },
        {
          threshold: [0.7],
        },
      );

      observer.observe(el);
    });

    document.querySelectorAll(".media-block").forEach((el) => {
      const asMultipleVideos = el.querySelectorAll(".media-item.as-video").length > 1;

      if (!asMultipleVideos) {
        el.querySelectorAll("video").forEach((video) => {
          const observer = new IntersectionObserver(
            async ([e]) => {
              if (e.isIntersecting) {
                try {
                  await video.play();
                } catch (err) {
                  console.error(err);
                }
                observer.disconnect();
              }
            },
            {
              threshold: [0.7],
            },
          );

          observer.observe(el);
        });
      }
    });
  },
};
